import ColeAvatar from "../assets/avatars/cole.png";
import FaizaAvatar from "../assets/avatars/faiza.png";
import MikalaAvatar from "../assets/avatars/mikala.png";
import SarthakAvatar from "../assets/avatars/sarthak.png";
import ThomasAvatar from "../assets/avatars/thomas.png";

// inspired by TexasVotes project. https://gitlab.com/forbesye/fitsbits/-/blob/master/front-end/src/views/About/AboutInfo.js

const teamInfo = [
  {
    name: "Cole Amlong",
    gitlab_username: "coleamlong",
    email: "coleamlong@gmail.com",
    image: ColeAvatar,
    role: "Front-end",
    bio: "I'm a third year student at the University of Texas at Austin pursuing a BS in computer sciecne and a minor in business. I love to cook declicous food and discover new music. Catch me on the weekends DJing events!",
    commits: 0,
    issues: 0,
    unit_tests: 15,
  },
  {
    name: "Faiza Rahman",
    gitlab_username: "faiza2002",
    email: "faiza2002@gmail.com",
    image: FaizaAvatar,
    role: "Front-end",
    bio: "I'm a third-year CS major at UT Austin. I'm mostly interested in contributing to the front-end work of this project as I have worked in the past only on the backend. In my freetime, I like to watch movies with friends or cook new recipes.",
    commits: 0,
    issues: 0,
    unit_tests: 0,
  },
  {
    name: "Mikala Jaramillo",
    gitlab_username: "Mikalajj",
    email: "jaramillomikala@utexas.edu",
    image: MikalaAvatar,
    role: "Front-end",
    bio: "I am a Senior at the University of Texas and I will be graduating in the fall with a Bachelor’s in Computer Science. I enjoy playing golf as one of my hobbies.",
    commits: 0,
    issues: 0,
    unit_tests: 0,
  },
  {
    name: "Sarthak Sirotiya",
    gitlab_username: "sarthaksirotiya",
    email: "sarthakssi2@gmail.com",
    image: SarthakAvatar,
    role: "AWS & Front-end",
    bio: "I'm a third year CS major at UT Austin, and I'm from Colleyville, Texas. I enjoy skiing (I've done it exactly once), playing racquetball, and cooking.",
    commits: 0,
    issues: 0,
    unit_tests: 0,
  },
  {
    name: "Thomas Langford",
    gitlab_username: "thomas_langford",
    email: "thomaslangford0123@gmail.com",
    image: ThomasAvatar,
    role: "Back-end",
    bio: "I'm a third year computer science major at the University of Texas at Austin. I enjoy playing the double bass and mountain biking.",
    commits: 0,
    issues: 0,
    unit_tests: 30,
  },
];

export { teamInfo };
